module.exports = __webpack_public_path__ + "static/aulario-16c77c2e96b2684c452fe822638fb28a.jpg";